// Slide-game runtime UI: instructions, feedback, timers, "Correct!", etc.
const dict = {
  uk: {
    common: {
      check: 'Перевірити',
      finish: 'Завершити',
      tryAgain: 'Спробувати ще',
      correct: 'Правильно!',
      wrong: 'Неправильно',
      notAllCorrect: 'Не всі правильні',
      readyToCheck: 'Готово до перевірки',
      start: 'Почати',
      playAudio: 'Відтворити аудіо',
      playSound: 'Відтворити звук',
      soundAdded: 'До завдання додано звук',
      noSound: 'Звук не додано',
      sound: 'Звук',
      audio: 'Аудіо',
      slide: 'Слайд',
    },
    frame: {
      addPhotoOrVideo: 'Додайте фото, GIF або відео',
    },
    flipCard: {
      front: 'Передня сторона',
      back: 'Задня сторона',
      label: 'Flip-картка',
    },
    spinWheel: {
      label: 'Колесо',
    },
    inputField: {
      placeholder: 'Поле вводу',
    },
    notebook: {
      placeholder: 'Пиши тут…',
    },
    exercise: {
      questionPlaceholder: 'Введіть питання...',
      noQuestion: 'Питання не задано',
      optionFallback: 'Варіант {{index}}',
    },
    anagram: {
      enterWordInSettings: 'Введіть слово в налаштуваннях',
    },
    missingLetters: {
      enterWordInSettings: 'Введіть слово в налаштуваннях',
    },
    chooseWord: {
      addSentenceHint: 'Додайте речення у налаштуваннях. Приклад:',
      sentenceFallback: 'Речення {{index}}',
    },
    fixMistake: {
      addSentenceHint: 'Додайте речення з помилками у налаштуваннях. Приклад:',
      sentenceFallback: 'Речення {{index}}',
      correctionHint: 'Правильна відповідь (видно лише вчителю)',
    },
    fillGaps: {
      enterTextInSettings: 'Введіть текст і додайте пропуски у налаштуваннях',
    },
    abcd: {
      addQuestionsInSettings: 'Додайте питання у налаштуваннях',
      questionFallback: 'Питання {{index}}',
    },
    trueFalse: {
      addStatementsInSettings: 'Додайте твердження у налаштуваннях',
      statementFallback: 'Твердження {{index}}',
    },
    pronounce: {
      label: 'Вимова',
      enterWord: 'Введи слово…',
      wordNotSet: 'Слово ще не задано',
      listen: 'Прослухати',
      stop: 'Зупинити',
      speakWord: 'Натисни і скажи слово',
      tapMicAndSpeak: 'Натисни на мікрофон і скажи слово',
      listening: 'Слухаю…',
      heard: 'Почули',
      good: 'Добре!',
      tryAgainShort: 'Спробуй ще',
      errBrowser: 'Браузер не підтримує розпізнавання мовлення. Спробуй Chrome, Edge або Safari.',
      errMicDenied: 'Доступ до мікрофона заборонено. Дозволь у налаштуваннях браузера.',
      errNoSpeech: 'Не почули жодного слова. Спробуй ще раз.',
      errNoMic: 'Мікрофон не знайдено.',
      errRecognition: 'Помилка розпізнавання. Спробуй ще раз.',
      errStart: 'Не вдалося запустити мікрофон.',
    },
    typeAnswer: {
      placeholder: 'Введіть відповідь...',
      enterQuestionInSettings: 'Введіть питання в налаштуваннях',
    },
    oddOneOut: {
      label: 'Зайве слово',
      odd: 'Зайвий',
      addRowsInSettings: 'Додайте рядки в налаштуваннях',
      chooseOddEachRow: 'Оберіть зайвий елемент у кожному рядку',
      chooseOddProgress: 'Оберіть зайве у кожному рядку ({{done}}/{{total}})',
      allRowsCorrect: 'Усі рядки правильні! {{done}}/{{total}}',
      correctCount: 'Правильно: {{done}}/{{total}}',
      row: 'рядок',
      rows: 'рядків',
      point: 'бал',
      points: 'балів',
      rowAudioLabel: 'Рядок {{row}}, аудіо {{index}}',
    },
    matchLines: {
      addPairsInSettings: 'Додайте пари у налаштуваннях, щоб створити вправу',
      dotLeft: 'Точка зліва',
      dotRight: 'Точка справа',
    },
    labelImage: {
      addImageAndItems: 'Додайте зображення та мітки у налаштуваннях',
      addImage: 'Додайте зображення у налаштуваннях',
      labelDot: 'Крапка мітки',
      imageDot: 'Крапка на зображенні',
    },
    sorting: {
      label: 'Сортування',
      addCategoriesInSettings: 'Додайте категорії та елементи в налаштуваннях',
      categoryFallback: 'Категорія',
      table: 'таблиця',
      baskets: 'корзинки',
      category: 'категорія',
      categories: 'категорій',
      item: 'елемент',
      items: 'елементів',
      allSorted: 'Усі елементи розсортовані',
      sortAllProgress: 'Розсортуйте усі елементи ({{done}}/{{total}})',
      allCorrect: 'Усе правильно! {{done}}/{{total}}',
      correctCount: 'Правильно: {{done}}/{{total}}',
    },
    dragLabel: {
      addLabelsInSettings: 'Додайте ярлики у налаштуваннях',
      addSlotsInSettings: 'Додайте слоти у налаштуваннях',
      allLabelsPlaced: 'Усі ярлики розставлені',
      uploadImageInSettings: 'Завантажте картинку у налаштуваннях',
      correctOf: '{{done}} з {{total}}',
    },
    puzzle: {
      uploadImageHint: 'Завантажте картинку в налаштуваннях, щоб зʼявились пазли',
      progress: '{{done}} з {{total}}',
      completed: 'Готово! Картинка зібрана',
    },
    wordPool: {
      minLetters: 'Мінімум {{count}} літери',
      alreadyFound: 'Вже знайдено',
      notInDictionary: 'Слова немає у словнику',
      notInList: 'Слова немає у списку',
      addLetters: 'Додати',
      clear: 'Очистити',
      wordLabel: 'Слово:',
      lettersNotFilled: 'Літери ще не заповнені',
      fillLettersInSettings: 'Заповніть літери в налаштуваннях',
      timeLimit: 'На час: {{time}}',
      timedStart: 'Почати',
      lettersAppearOnStart: 'Літери з\'являться, коли запустиш таймер ({{time}})',
      findWordsCount: 'Знайди слова ({{count}}):',
      found: 'Знайдено: {{count}}',
      minWords: 'з мін. {{count}}',
      minWordsPlural: 'мін. {{count}} {{unit}}',
      wordSingular: 'слово',
      wordPlural: 'слів',
      targets: 'Цілі: {{done}}/{{total}}',
      bonus: 'Бонус ({{count}}):',
      allWordsFound: 'Усі слова знайдено!',
      notFound: 'Не знайдено: {{words}}',
      foundWordsCount: 'Знайдено {{count}} {{unit}}!',
      foundWordsOfMin: 'Знайдено {{count}} з мінімум {{min}}',
    },
    unjumble: {
      enterSentenceInSettings: 'Введіть речення в налаштуваннях',
      correctOf: 'Правильно! {{done}}/{{total}}',
      wrongOf: '{{done}}/{{total}} правильно',
    },
    orderSentences: {
      enterSentencesInSettings: 'Додайте речення в налаштуваннях',
    },
    rank: {
      addItemsInSettings: 'Додайте елементи в налаштуваннях',
      allRanked: 'Усі елементи розставлені',
      itemFallback: 'Елемент {{index}}',
    },
    hud: {
      streakCount: 'в ряд',
      mistakes: 'помилок: {{count}}',
    },
    settingsPopover: {
      title: 'Налаштування',
      openLabel: 'Налаштування ігор',
      sound: 'Звук',
      vibration: 'Вібрація',
      confetti: 'Конфеті',
    },
    ken: {
      happy: 'Так тримати! 🎉',
      streak: 'Ти в ударі! 🔥',
      sad: 'Спробуй ще 💪',
      thinking: 'Хмм…',
      celebrate: 'Ура!!! 🎊',
    },
    player: {
      ready: 'Готовий?',
      start: 'Почати',
      skipTitle: 'Клікни, щоб пропустити',
      loading: 'Завантаження…',
      unknownType: 'Невідомий тип гри',
      previewBadge: 'Перегляд',
      saveError: 'Не вдалося зберегти результат',
      excellent: 'Чудово!',
      wellDone: 'Молодець!',
      tryAgainFull: 'Спробуй ще раз!',
      result: 'Результат: {{score}}/100',
      saving: 'Збереження результату…',
      saveErrorDetail: 'Не вдалося зберегти результат: {{error}}. Перезайди в акаунт і спробуй ще раз.',
      playAgain: 'Зіграти ще раз',
      finish: 'Завершити',
    },
    common2: {
      notConfigured: 'Гру не налаштовано',
      completed: 'Завершено!',
      listen: 'Послухати',
      again: 'Ще раз',
      listenAgainTitle: 'Прослухати ще раз',
      ttsUnsupported: 'Твій браузер не підтримує озвучування',
      playedCount: 'Прослухано: {{count}}',
      correctAnswer: 'Правильна відповідь:',
      check: 'Перевірити',
      next: 'Далі',
      continue: 'Продовжити',
    },
    dictationPlayer: {
      hint: 'Послухай Кена й запиши, що почув',
      inputPlaceholder: 'Запиши те, що почув…',
    },
    listenTypePlayer: {
      hint: 'Прослухай аудіо й набери що почув',
      playAudio: 'Відтворити аудіо',
      inputPlaceholder: 'Введи відповідь…',
    },
    listenPickWordPlayer: {
      hint: 'Прослухай слово й обери яке з двох ти чуєш',
    },
    listenPickImagePlayer: {
      hint: 'Прослухай слово й обери правильну картинку',
    },
    pickPronunciationPlayer: {
      hint: 'Обери іконку, яка вимовляє написане слово',
      word: 'Слово',
      option: 'Варіант {{n}}',
      pick: 'Обрати',
      tapIconHint: 'Натисни на іконку, щоб почути звук',
    },
    pairOrNoPairPlayer: {
      hint: 'Чи ці дві картки належать одна одній?',
      correct: 'Правильно!',
      wrongPair: 'Неправильно — це пара',
      wrongNoPair: 'Неправильно — це не пара',
    },
    sortingPlayer: {
      hintPrefix: 'Перетягни слова в правильні {{container}}',
      containerBox: 'коробки',
      containerBasket: 'кошики',
      containerBin: 'смітники',
      wordsLabel: 'Слова:',
      allSorted: 'Усі слова розсортовані',
    },
    thisOrThatPlayer: {
      hint: 'Обери правильний варіант',
      noQuestion: '(без питання)',
    },
    labelledDiagramPlayer: {
      hint: 'Перетягни підписи на правильні точки на картинці',
      labelsLabel: 'Підписи:',
      allPlaced: 'Усі підписи розставлені',
    },
    findObjectPlayer: {
      hint: 'Знайди предмет на картинці',
      find: 'Знайди',
      allFound: 'Усі знайдено!',
    },
    nmtImage: {
      uploadInSettings: 'Завантаж картинки та додай варіанти в налаштуваннях',
      noImage: 'Немає картинки',
      pickAnswer: 'Познач відповідь:',
      progress: '{{current}} / {{total}}',
      imageCount: 'Картинок: {{count}}',
      answer: 'Відповісти',
      skip: 'Пропустити',
      showAnswer: 'Показати відповідь',
      next: 'Наступне',
      resultTitle: 'Результат',
      resultScore: 'Правильно: {{correct}} з {{total}}',
      zoom: 'Збільшити картинку',
      closeZoom: 'Закрити',
    },
    sunscreenPlayer: {
      notConfigured: 'Гру не налаштовано. Обери частини тіла в редакторі.',
      hint: 'Намасти Кену крем — перетягни тюбик',
    },
    spellPicturePlayer: {
      hint: 'Впиши слово по картинці',
      enterWord: 'Введи слово',
      erase: 'Стерти',
    },
    memoryPlayer: {
      notConfigured: 'Гру не налаштовано (потрібно мінімум 2 пари)',
      hint: 'Знайди пари: слово ↔ картинка',
    },
    memory: {
      finished: 'Готово!',
      reset: 'Почати знову',
    },
    kissMarryAvoid: {
      taken: 'Вже обрано для іншого персонажа',
    },
    dressUp: {
      reset: 'Зняти все',
      emptyWardrobe: 'Додайте одяг у налаштуваннях',
    },
    boardGame: {
      roll: 'Кинути',
      done: 'Готово',
      reset: 'Почати спочатку',
      winner: '{{name}} перемагає!',
      playAgain: 'Грати ще',
      jumpForward: 'Вперед на {{count}}',
      jumpBack: 'Назад на {{count}}',
    },
    spotDifference: {
      reset: 'Почати спочатку',
    },
    mindMap: {
      addBranch: 'Додати гілку',
      addLeaf: 'Додати ідею',
    },
    dialogue: {
      restart: 'Почати діалог спочатку',
      end: '— кінець діалогу —',
    },
    pictionary: {
      student: 'Учень',
      teacher: 'Вчитель',
      modeDuo: 'Учень ↔ вчитель',
      modeTeams: 'Команди ({{count}})',
      wordsCount: '{{count}} слів',
      noWords: 'Додайте слова в налаштуваннях',
      introDuo: 'Малюємо по черзі: один малює загадане слово, інший вгадує вголос.',
      introTeams: 'Команди по черзі малюють слово, решта вгадує. За кожне вгадане слово — бал команді.',
      start: 'Почати гру',
      waitingForTeacher: 'Чекаємо, поки вчитель почне гру…',
      teamWins: 'Перемагає {{name}}!',
      gameOver: 'Гру завершено!',
      playAgain: 'Грати ще',
      draw: 'Малюй:',
      teamDraws: 'Малює {{name}}',
      guess: 'Вгадай, що малює {{name}}!',
      resultGuessed: 'Вгадали!',
      resultSkipped: 'Пропущено.',
      resultTimeout: 'Час вийшов.',
      wordWas: 'Слово:',
      peek: 'Затисни, щоб побачити слово',
      results: 'Результати',
      nextTeam: 'Далі: {{name}}',
      nextRound: 'Наступний раунд',
      myTurn: 'Моя черга малювати',
      waitingFor: '{{name}} малює наступним…',
      finish: 'Завершити гру',
      eraser: 'Гумка',
      undo: 'Скасувати',
      clear: 'Очистити',
      skip: 'Пропустити',
      guessed: 'Вгадано',
    },
    personalityQuiz: {
      yourResult: 'Твій результат:',
      restart: 'Пройти ще раз',
      back: 'Назад',
    },
    editors: {
      common: {
        add: 'Додати',
        delete: 'Видалити',
        replace: 'Замінити',
        upload: 'Завантажити',
        listen: 'Прослухати',
        picture: 'Картинка',
        word: 'Слово',
        selectImage: 'Будь ласка, обери файл картинки',
        uploadFailed: 'Не вдалось завантажити картинку',
        slow: 'Повільно',
        normal: 'Нормально',
        fast: 'Швидко',
        voiceLanguage: 'Мова озвучення',
        speed: 'Швидкість',
        dropToUpload: 'Відпусти щоб завантажити',
        clickOrDrag: 'Натисни або перетягни картинку сюди',
        fileTypes: 'JPEG, PNG, GIF, WebP — до 10 МБ',
        clickPictureAfterUpload: 'Після завантаження клікай на картинку щоб додати точки',
        dropToReplace: 'Відпусти щоб замінити',
        replaceOrDrag: 'Замінити (або перетягни сюди)',
        removeImage: 'Прибрати картинку',
        clickOrUpload: 'Натисни щоб завантажити картинку',
        clickOrDragImageRow: 'Натисни або перетягни картинку сюди',
      },
      pairOrNoPair: {
        title: 'Раунди (мінімум 4)',
        roundsCount: '{{count}} раундів',
        leftCard: 'Ліва картка',
        rightCard: 'Права картка',
        addRound: 'Додати раунд',
        atLeast4: 'Рекомендуємо щонайменше 4 раунди',
        hint: 'Постав галочку якщо ці дві картки належать одна одній (правильна пара). Зніми — якщо це не пара.',
      },
      listenPickImage: {
        title: 'Слова та картинки',
        wordsCount: '{{count}} слів',
        wordPlaceholder: 'Слово (те, що Кен озвучить)',
        addWord: 'Додати слово',
        atLeast4: 'Рекомендуємо щонайменше 4 слова — щоб на кожному раунді було 4 варіанти картинок',
        hint: 'Кен озвучить слово голосом браузера. У раунді буде правильна картинка + до 3 інших картинок з цього списку.',
      },
      thisOrThat: {
        title: 'Раунди (мінімум 4)',
        roundsCount: '{{count}} раундів',
        round: 'Раунд {{n}}',
        removeRound: 'Видалити раунд',
        promptPlaceholder: 'Текст питання (або залиш пустим якщо є картинка)',
        optionPlaceholder: 'Варіант {{letter}}',
        correct: 'Правильна',
        markCorrect: 'Позначити правильною',
        addRound: 'Додати раунд',
        atLeast4: 'Рекомендуємо щонайменше 4 раунди',
        hint: 'В центрі — текст або картинка. Внизу два варіанти (текст або картинка). Обери правильний радіокнопкою.',
      },
      sunscreen: {
        title: 'Sunscreen on Ken',
        description: 'Учень тягне тюбик крему на правильну частину тіла Кена. Хітбокси вже налаштовані під стандартну картинку Кена.',
        bodyParts: 'Частини тіла',
        enabled: 'Увімкнено: {{done}}/{{total}}',
        kenPicture: 'Картинка Кена',
        kenDescription: 'За замовчуванням використовуємо стандартного Кена. Заміняй тільки якщо картинка тієї ж пози — інакше хітбокси не збігатимуться.',
        replacePicture: 'Замінити картинку',
        uploadYourOwn: 'Завантажити свою',
        restoreDefault: 'Повернути стандартну',
      },
      sorting: {
        containerTitle: 'Куди сортувати?',
        boxes: 'Коробки',
        baskets: 'Кошики',
        bins: 'Смітники',
        categoriesTitle: 'Категорії ({{min}}–{{max}})',
        categoryPlaceholder: 'Категорія {{n}} (напр. Фрукти)',
        minCategories: 'Мінімум {{min}} категорії',
        addCategory: 'Додати категорію',
        wordsTitle: 'Слова',
        wordsCount: '{{count}} слів',
        wordPlaceholder: 'Слово',
        noCategories: '— немає категорій —',
        untitled: 'Без назви',
        addWord: 'Додати слово',
        atLeast4: 'Рекомендуємо щонайменше 4 слова для гри',
      },
      pickPronunciation: {
        title: 'Слова',
        wordsCount: '{{count}} слів',
        wordPlaceholder: 'Слово (напр. apple)',
        minWords: 'Потрібно щонайменше 2 слова',
        addWord: 'Додати слово',
        atLeast2: 'Потрібно щонайменше 2 слова — щоб було з чого обирати',
        hint: 'У кожному раунді учень бачить одне слово і дві іконки-звуки. Одна іконка вимовляє показане слово, друга — інше слово з цього списку (випадкове).',
      },
      listenPickWord: {
        title: 'Слова',
        wordsCount: '{{count}} слів',
        wordPlaceholder: 'Слово (напр. apple)',
        minWords: 'Потрібно щонайменше 2 слова',
        addWord: 'Додати слово',
        atLeast2: 'Потрібно щонайменше 2 слова — щоб було з чого обирати',
        hint: 'У кожному раунді учень чує одне слово і бачить дві картки з текстом. Одна картка — це слово, що прозвучало, друга — інше слово з цього списку (випадкове). Учень тапає ту, яку почув.',
      },
      memory: {
        title: 'Пари (мінімум 4)',
        pairsCount: '{{count}} пар',
        wordPlaceholder: 'Слово',
        addPair: 'Додати пару',
        atLeast4: 'Рекомендуємо щонайменше 4 пари для гри',
        hint: 'Перетягни картинку прямо на рядок щоб завантажити',
      },
      findObject: {
        title: 'Знайди предмет',
        description: 'Завантаж картинку з багатьма предметами. Клікай на предметах щоб додати підказки, і впиши слово для кожної.',
        clickImageAfterUpload: 'Після завантаження клікай на предмети щоб додати підказки',
        pointN: 'Точка {{n}}',
        clickToAdd: 'Натисни на картинку щоб додати точку. {{count}} {{unit}}',
        item: 'предмет',
        items: 'предметів',
        objectsTitle: 'Предмети',
        wordPlaceholder: 'напр. apple',
        radius: 'Радіус',
      },
      labelledDiagram: {
        title: 'Картинка з підписами',
        clickToAdd: 'Натисни на картинку щоб додати точку. {{count}} точок',
        labelsTitle: 'Підписи до точок',
        labelPlaceholder: 'Підпис до точки',
      },
      listenType: {
        title: 'Аудіо-завдання',
        tasksCount: '{{count}} завдань',
        selectAudio: 'Будь ласка, обери аудіо-файл',
        uploadAudioFailed: 'Не вдалось завантажити аудіо',
        task: 'Завдання {{n}}',
        dropToUpload: 'Відпусти щоб завантажити',
        dragAudioHere: 'Перетягни аудіо сюди або натисни кнопку →',
        correctAnswer: 'Правильна відповідь',
        answerPlaceholder: 'напр. The cat is sleeping',
        otherVariants: "Інші прийнятні варіанти (через кому, необов'язково)",
        variantsPlaceholder: 'напр. The cat sleeps, A cat is sleeping',
        addTask: 'Додати завдання',
        dragAudioHint: 'Перетягни аудіо-файл прямо на блок завдання',
      },
      spellPicture: {
        title: 'Слова (мінімум 4)',
        wordsCount: '{{count}} слів',
        wordPlaceholder: 'Слово (напр. cat)',
        letters: 'букв',
        addWord: 'Додати слово',
        atLeast4: 'Рекомендуємо щонайменше 4 слова',
        hint: 'Для кожного слова — картинка та саме слово. Учень бачить картинку і риски (по одній на кожну букву) і має ввести слово.',
      },
      dictation: {
        title: 'Фрази для диктанту',
        phrasesCount: '{{count}} фраз',
        phrase: 'Фраза {{n}}',
        textLabel: 'Текст, який Кен озвучить (і правильна відповідь)',
        textPlaceholder: 'напр. The cat is sleeping on the sofa',
        otherVariants: "Інші прийнятні варіанти (через кому, необов'язково)",
        variantsPlaceholder: 'напр. The cat sleeps on the sofa',
        addPhrase: 'Додати фразу',
        hint: 'Кен озвучить текст голосом браузера. Порівняння з відповіддю не враховує регістр і знаки пунктуації.',
      },
    },
  },
  en: {
    common: {
      check: 'Check',
      finish: 'Finish',
      tryAgain: 'Try again',
      correct: 'Correct!',
      wrong: 'Wrong',
      notAllCorrect: 'Not all correct',
      readyToCheck: 'Ready to check',
      start: 'Start',
      playAudio: 'Play audio',
      playSound: 'Play sound',
      soundAdded: 'Sound added to task',
      noSound: 'No sound added',
      sound: 'Sound',
      audio: 'Audio',
      slide: 'Slide',
    },
    frame: {
      addPhotoOrVideo: 'Add photo, GIF or video',
    },
    flipCard: {
      front: 'Front side',
      back: 'Back side',
      label: 'Flip card',
    },
    spinWheel: {
      label: 'Spin wheel',
    },
    inputField: {
      placeholder: 'Input field',
    },
    notebook: {
      placeholder: 'Write here…',
    },
    exercise: {
      questionPlaceholder: 'Enter a question...',
      noQuestion: 'No question set',
      optionFallback: 'Option {{index}}',
    },
    anagram: {
      enterWordInSettings: 'Enter a word in settings',
    },
    missingLetters: {
      enterWordInSettings: 'Enter a word in settings',
    },
    chooseWord: {
      addSentenceHint: 'Add sentences in settings. Example:',
      sentenceFallback: 'Sentence {{index}}',
    },
    fixMistake: {
      addSentenceHint: 'Add sentences with mistakes in settings. Example:',
      sentenceFallback: 'Sentence {{index}}',
      correctionHint: 'Correct answer (visible only to the teacher)',
    },
    fillGaps: {
      enterTextInSettings: 'Enter text and add gaps in settings',
    },
    abcd: {
      addQuestionsInSettings: 'Add questions in settings',
      questionFallback: 'Question {{index}}',
    },
    trueFalse: {
      addStatementsInSettings: 'Add statements in settings',
      statementFallback: 'Statement {{index}}',
    },
    pronounce: {
      label: 'Pronounce',
      enterWord: 'Enter word…',
      wordNotSet: 'Word not set',
      listen: 'Listen',
      stop: 'Stop',
      speakWord: 'Tap and say the word',
      tapMicAndSpeak: 'Tap the mic and say the word',
      listening: 'Listening…',
      heard: 'Heard',
      good: 'Good!',
      tryAgainShort: 'Try again',
      errBrowser: 'Your browser does not support speech recognition. Try Chrome, Edge or Safari.',
      errMicDenied: 'Microphone access denied. Allow it in browser settings.',
      errNoSpeech: 'No words heard. Try again.',
      errNoMic: 'No microphone found.',
      errRecognition: 'Recognition error. Try again.',
      errStart: 'Could not start the microphone.',
    },
    typeAnswer: {
      placeholder: 'Type your answer...',
      enterQuestionInSettings: 'Enter a question in settings',
    },
    oddOneOut: {
      label: 'Odd one out',
      odd: 'Odd',
      addRowsInSettings: 'Add rows in settings',
      chooseOddEachRow: 'Pick the odd item in each row',
      chooseOddProgress: 'Pick the odd item in each row ({{done}}/{{total}})',
      allRowsCorrect: 'All rows correct! {{done}}/{{total}}',
      correctCount: 'Correct: {{done}}/{{total}}',
      row: 'row',
      rows: 'rows',
      point: 'point',
      points: 'points',
      rowAudioLabel: 'Row {{row}}, audio {{index}}',
    },
    matchLines: {
      addPairsInSettings: 'Add pairs in settings to create the exercise',
      dotLeft: 'Left dot',
      dotRight: 'Right dot',
    },
    labelImage: {
      addImageAndItems: 'Add an image and labels in the settings',
      addImage: 'Add an image in the settings',
      labelDot: 'Label dot',
      imageDot: 'Image dot',
    },
    sorting: {
      label: 'Sorting',
      addCategoriesInSettings: 'Add categories and items in settings',
      categoryFallback: 'Category',
      table: 'table',
      baskets: 'baskets',
      category: 'category',
      categories: 'categories',
      item: 'item',
      items: 'items',
      allSorted: 'All items sorted',
      sortAllProgress: 'Sort all items ({{done}}/{{total}})',
      allCorrect: 'All correct! {{done}}/{{total}}',
      correctCount: 'Correct: {{done}}/{{total}}',
    },
    dragLabel: {
      addLabelsInSettings: 'Add labels in settings',
      addSlotsInSettings: 'Add slots in settings',
      allLabelsPlaced: 'All labels placed',
      uploadImageInSettings: 'Upload an image in settings',
      correctOf: '{{done}} of {{total}}',
    },
    puzzle: {
      uploadImageHint: 'Upload an image in settings to generate the pieces',
      progress: '{{done}} of {{total}}',
      completed: 'Done! Picture assembled',
    },
    wordPool: {
      minLetters: 'At least {{count}} letters',
      alreadyFound: 'Already found',
      notInDictionary: 'Word not in dictionary',
      notInList: 'Word not in list',
      addLetters: 'Add',
      clear: 'Clear',
      wordLabel: 'Word:',
      lettersNotFilled: 'Letters not yet filled',
      fillLettersInSettings: 'Fill in letters in settings',
      timeLimit: 'Timed: {{time}}',
      timedStart: 'Start',
      lettersAppearOnStart: 'Letters will appear when you start the timer ({{time}})',
      findWordsCount: 'Find words ({{count}}):',
      found: 'Found: {{count}}',
      minWords: 'min. {{count}}',
      minWordsPlural: 'min. {{count}} {{unit}}',
      wordSingular: 'word',
      wordPlural: 'words',
      targets: 'Targets: {{done}}/{{total}}',
      bonus: 'Bonus ({{count}}):',
      allWordsFound: 'All words found!',
      notFound: 'Not found: {{words}}',
      foundWordsCount: 'Found {{count}} {{unit}}!',
      foundWordsOfMin: 'Found {{count}} of minimum {{min}}',
    },
    unjumble: {
      enterSentenceInSettings: 'Enter sentences in settings',
      correctOf: 'Correct! {{done}}/{{total}}',
      wrongOf: '{{done}}/{{total}} correct',
    },
    orderSentences: {
      enterSentencesInSettings: 'Add sentences in settings',
    },
    rank: {
      addItemsInSettings: 'Add items in settings',
      allRanked: 'All items placed',
      itemFallback: 'Item {{index}}',
    },
    hud: {
      streakCount: 'in a row',
      mistakes: 'mistakes: {{count}}',
    },
    settingsPopover: {
      title: 'Settings',
      openLabel: 'Game settings',
      sound: 'Sound',
      vibration: 'Vibration',
      confetti: 'Confetti',
    },
    ken: {
      happy: 'Keep it up! 🎉',
      streak: "You're on fire! 🔥",
      sad: 'Try again 💪',
      thinking: 'Hmm…',
      celebrate: 'Yay!!! 🎊',
    },
    player: {
      ready: 'Ready?',
      start: 'Start',
      skipTitle: 'Click to skip',
      loading: 'Loading…',
      unknownType: 'Unknown game type',
      previewBadge: 'Preview',
      saveError: 'Could not save result',
      excellent: 'Excellent!',
      wellDone: 'Well done!',
      tryAgainFull: 'Try again!',
      result: 'Score: {{score}}/100',
      saving: 'Saving result…',
      saveErrorDetail: 'Could not save result: {{error}}. Please sign in again and try once more.',
      playAgain: 'Play again',
      finish: 'Finish',
    },
    common2: {
      notConfigured: 'Game not configured',
      completed: 'Finished!',
      listen: 'Listen',
      again: 'Again',
      listenAgainTitle: 'Listen again',
      ttsUnsupported: 'Your browser does not support text-to-speech',
      playedCount: 'Played: {{count}}',
      correctAnswer: 'Correct answer:',
      check: 'Check',
      next: 'Next',
      continue: 'Continue',
    },
    dictationPlayer: {
      hint: 'Listen to Ken and type what you heard',
      inputPlaceholder: 'Type what you heard…',
    },
    listenTypePlayer: {
      hint: 'Listen to the audio and type what you heard',
      playAudio: 'Play audio',
      inputPlaceholder: 'Type your answer…',
    },
    listenPickWordPlayer: {
      hint: 'Listen to the word and pick which one you hear',
    },
    listenPickImagePlayer: {
      hint: 'Listen to the word and pick the correct picture',
    },
    pickPronunciationPlayer: {
      hint: 'Pick the icon that pronounces the written word',
      word: 'Word',
      option: 'Option {{n}}',
      pick: 'Pick',
      tapIconHint: 'Tap an icon to hear the sound',
    },
    pairOrNoPairPlayer: {
      hint: 'Do these two cards belong together?',
      correct: 'Correct!',
      wrongPair: "Wrong — it's a pair",
      wrongNoPair: "Wrong — it's not a pair",
    },
    sortingPlayer: {
      hintPrefix: 'Drag the words into the right {{container}}',
      containerBox: 'boxes',
      containerBasket: 'baskets',
      containerBin: 'bins',
      wordsLabel: 'Words:',
      allSorted: 'All words sorted',
    },
    thisOrThatPlayer: {
      hint: 'Pick the correct option',
      noQuestion: '(no question)',
    },
    labelledDiagramPlayer: {
      hint: 'Drag the labels onto the correct points on the picture',
      labelsLabel: 'Labels:',
      allPlaced: 'All labels placed',
    },
    findObjectPlayer: {
      hint: 'Find the object in the picture',
      find: 'Find',
      allFound: 'All found!',
    },
    nmtImage: {
      uploadInSettings: 'Upload pictures and add options in settings',
      noImage: 'No picture',
      pickAnswer: 'Mark your answer:',
      progress: '{{current}} / {{total}}',
      imageCount: 'Pictures: {{count}}',
      answer: 'Answer',
      skip: 'Skip',
      showAnswer: 'Show answer',
      next: 'Next',
      resultTitle: 'Result',
      resultScore: 'Correct: {{correct}} of {{total}}',
      zoom: 'Enlarge image',
      closeZoom: 'Close',
    },
    sunscreenPlayer: {
      notConfigured: 'Game not configured. Pick body parts in the editor.',
      hint: "Put sunscreen on Ken — drag the tube",
    },
    spellPicturePlayer: {
      hint: 'Type the word from the picture',
      enterWord: 'Type the word',
      erase: 'Erase',
    },
    memoryPlayer: {
      notConfigured: 'Game not configured (at least 2 pairs required)',
      hint: 'Find pairs: word ↔ picture',
    },
    memory: {
      finished: 'All done!',
      reset: 'Start over',
    },
    kissMarryAvoid: {
      taken: 'Already given to another character',
    },
    dressUp: {
      reset: 'Take everything off',
      emptyWardrobe: 'Add clothes in the settings',
    },
    boardGame: {
      roll: 'Roll',
      done: 'Done',
      reset: 'Start over',
      winner: '{{name}} wins!',
      playAgain: 'Play again',
      jumpForward: 'Go forward {{count}}',
      jumpBack: 'Go back {{count}}',
    },
    spotDifference: {
      reset: 'Start over',
    },
    mindMap: {
      addBranch: 'Add branch',
      addLeaf: 'Add idea',
    },
    dialogue: {
      restart: 'Restart the dialogue',
      end: '— end of dialogue —',
    },
    pictionary: {
      student: 'Student',
      teacher: 'Teacher',
      modeDuo: 'Student ↔ teacher',
      modeTeams: 'Teams ({{count}})',
      wordsCount: '{{count}} words',
      noWords: 'Add words in the settings',
      introDuo: 'Take turns: one draws the secret word, the other guesses out loud.',
      introTeams: 'Teams take turns drawing a word while the others guess. Each guessed word scores a point for the team.',
      start: 'Start game',
      waitingForTeacher: 'Waiting for the teacher to start…',
      teamWins: '{{name}} wins!',
      gameOver: 'Game over!',
      playAgain: 'Play again',
      draw: 'Draw:',
      teamDraws: '{{name}} is drawing',
      guess: 'Guess what the {{name}} is drawing!',
      resultGuessed: 'Guessed!',
      resultSkipped: 'Skipped.',
      resultTimeout: 'Time is up.',
      wordWas: 'The word:',
      peek: 'Hold to see the word',
      results: 'Results',
      nextTeam: 'Next: {{name}}',
      nextRound: 'Next round',
      myTurn: 'My turn to draw',
      waitingFor: '{{name}} draws next…',
      finish: 'End game',
      eraser: 'Eraser',
      undo: 'Undo',
      clear: 'Clear',
      skip: 'Skip',
      guessed: 'Guessed',
    },
    personalityQuiz: {
      yourResult: 'Your result:',
      restart: 'Take it again',
      back: 'Back',
    },
    editors: {
      common: {
        add: 'Add',
        delete: 'Delete',
        replace: 'Replace',
        upload: 'Upload',
        listen: 'Listen',
        picture: 'Picture',
        word: 'Word',
        selectImage: 'Please choose an image file',
        uploadFailed: 'Could not upload the picture',
        slow: 'Slow',
        normal: 'Normal',
        fast: 'Fast',
        voiceLanguage: 'Voice language',
        speed: 'Speed',
        dropToUpload: 'Drop to upload',
        clickOrDrag: 'Click or drag a picture here',
        fileTypes: 'JPEG, PNG, GIF, WebP — up to 10 MB',
        clickPictureAfterUpload: 'After upload, click the picture to add points',
        dropToReplace: 'Drop to replace',
        replaceOrDrag: 'Replace (or drag here)',
        removeImage: 'Remove picture',
        clickOrUpload: 'Click to upload a picture',
        clickOrDragImageRow: 'Click or drag a picture here',
      },
      pairOrNoPair: {
        title: 'Rounds (at least 4)',
        roundsCount: '{{count}} rounds',
        leftCard: 'Left card',
        rightCard: 'Right card',
        addRound: 'Add round',
        atLeast4: 'We recommend at least 4 rounds',
        hint: "Check the box if these two cards belong together (a correct pair). Uncheck it if they don't.",
      },
      listenPickImage: {
        title: 'Words and pictures',
        wordsCount: '{{count}} words',
        wordPlaceholder: 'Word (what Ken will say)',
        addWord: 'Add word',
        atLeast4: 'We recommend at least 4 words — so each round has 4 image options',
        hint: "Ken will say the word using the browser's voice. Each round shows the correct picture + up to 3 other pictures from this list.",
      },
      thisOrThat: {
        title: 'Rounds (at least 4)',
        roundsCount: '{{count}} rounds',
        round: 'Round {{n}}',
        removeRound: 'Remove round',
        promptPlaceholder: 'Prompt text (or leave empty if you have a picture)',
        optionPlaceholder: 'Option {{letter}}',
        correct: 'Correct',
        markCorrect: 'Mark as correct',
        addRound: 'Add round',
        atLeast4: 'We recommend at least 4 rounds',
        hint: 'In the center — text or picture. Below, two options (text or picture). Pick the correct one via the radio button.',
      },
      sunscreen: {
        title: 'Sunscreen on Ken',
        description: "Student drags the sunscreen tube onto the correct body part of Ken. Hitboxes are already set for the standard Ken picture.",
        bodyParts: 'Body parts',
        enabled: 'Enabled: {{done}}/{{total}}',
        kenPicture: "Ken's picture",
        kenDescription: "By default we use the standard Ken. Only replace if the picture uses the same pose — otherwise hitboxes won't match.",
        replacePicture: 'Replace picture',
        uploadYourOwn: 'Upload your own',
        restoreDefault: 'Restore default',
      },
      sorting: {
        containerTitle: 'Sort into what?',
        boxes: 'Boxes',
        baskets: 'Baskets',
        bins: 'Bins',
        categoriesTitle: 'Categories ({{min}}–{{max}})',
        categoryPlaceholder: 'Category {{n}} (e.g. Fruits)',
        minCategories: 'Minimum {{min}} categories',
        addCategory: 'Add category',
        wordsTitle: 'Words',
        wordsCount: '{{count}} words',
        wordPlaceholder: 'Word',
        noCategories: '— no categories —',
        untitled: 'Untitled',
        addWord: 'Add word',
        atLeast4: 'We recommend at least 4 words for the game',
      },
      pickPronunciation: {
        title: 'Words',
        wordsCount: '{{count}} words',
        wordPlaceholder: 'Word (e.g. apple)',
        minWords: 'At least 2 words required',
        addWord: 'Add word',
        atLeast2: 'At least 2 words are required — so there is something to pick from',
        hint: 'In each round the student sees one word and two sound icons. One icon speaks the shown word, the other — a different word from this list (random).',
      },
      listenPickWord: {
        title: 'Words',
        wordsCount: '{{count}} words',
        wordPlaceholder: 'Word (e.g. apple)',
        minWords: 'At least 2 words required',
        addWord: 'Add word',
        atLeast2: 'At least 2 words are required — so there is something to pick from',
        hint: 'In each round the student hears one word and sees two text cards. One card is the word that was said, the other — a different word from this list (random). The student taps the one they heard.',
      },
      memory: {
        title: 'Pairs (at least 4)',
        pairsCount: '{{count}} pairs',
        wordPlaceholder: 'Word',
        addPair: 'Add pair',
        atLeast4: 'We recommend at least 4 pairs for the game',
        hint: 'Drag a picture directly onto a row to upload',
      },
      findObject: {
        title: 'Find the object',
        description: 'Upload a picture with many objects. Click on objects to add hotspots and type a word for each.',
        clickImageAfterUpload: 'After upload, click objects to add hotspots',
        pointN: 'Point {{n}}',
        clickToAdd: 'Click the picture to add a point. {{count}} {{unit}}',
        item: 'object',
        items: 'objects',
        objectsTitle: 'Objects',
        wordPlaceholder: 'e.g. apple',
        radius: 'Radius',
      },
      labelledDiagram: {
        title: 'Picture with labels',
        clickToAdd: 'Click the picture to add a point. {{count}} points',
        labelsTitle: 'Labels for points',
        labelPlaceholder: 'Label for the point',
      },
      listenType: {
        title: 'Audio tasks',
        tasksCount: '{{count}} tasks',
        selectAudio: 'Please choose an audio file',
        uploadAudioFailed: 'Could not upload audio',
        task: 'Task {{n}}',
        dropToUpload: 'Drop to upload',
        dragAudioHere: 'Drag audio here or click the button →',
        correctAnswer: 'Correct answer',
        answerPlaceholder: 'e.g. The cat is sleeping',
        otherVariants: 'Other acceptable variants (comma-separated, optional)',
        variantsPlaceholder: 'e.g. The cat sleeps, A cat is sleeping',
        addTask: 'Add task',
        dragAudioHint: 'Drag an audio file directly onto the task block',
      },
      spellPicture: {
        title: 'Words (at least 4)',
        wordsCount: '{{count}} words',
        wordPlaceholder: 'Word (e.g. cat)',
        letters: 'letters',
        addWord: 'Add word',
        atLeast4: 'We recommend at least 4 words',
        hint: 'For each word — a picture and the word itself. The student sees the picture and dashes (one per letter) and must type the word.',
      },
      dictation: {
        title: 'Phrases for dictation',
        phrasesCount: '{{count}} phrases',
        phrase: 'Phrase {{n}}',
        textLabel: 'Text that Ken will say (and the correct answer)',
        textPlaceholder: 'e.g. The cat is sleeping on the sofa',
        otherVariants: 'Other acceptable variants (comma-separated, optional)',
        variantsPlaceholder: 'e.g. The cat sleeps on the sofa',
        addPhrase: 'Add phrase',
        hint: "Ken will say the text using the browser's voice. Comparison ignores case and punctuation.",
      },
    },
  },
};

export default dict;
